(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.SORTS = [
        'manual',
        'best-selling',
        'created-descending',
        'price-descending',
        'price-ascending',
        'title-ascending'
      ];
      new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.build().catch(e => console.error('[recs]', e));
      }, { rootMargin: '0px 0px 1200px 0px' }).observe(this);
    }

    /* セッション乱数：同一訪問中は固定、訪問が変われば顔ぶれが変わる */
    seed() {
      try {
        let s = sessionStorage.getItem('recsSeed');
        if (!s) {
          s = String(Math.floor(Math.random() * 100000));
          sessionStorage.setItem('recsSeed', s);
        }
        return parseInt(s, 10);
      } catch (e) {
        return 0;
      }
    }

    history() {
      try {
        return JSON.parse(localStorage.getItem('recsViewed') || '[]');
      } catch (e) {
        return [];
      }
    }

    recordHistory(handle) {
      try {
        const h = this.history().filter(x => x !== handle);
        h.unshift(handle);
        localStorage.setItem('recsViewed', JSON.stringify(h.slice(0, 20)));
      } catch (e) { /* noop */ }
    }

    async fetchSegment(tags, sort) {
      /* Shopify はタグ順を文字コード順に正規化し、違う順序で来ると 301 を返す。
         あらかじめ同じ順序に揃えて、無駄な往復を避ける。 */
      const path = tags.slice().sort().map(t => encodeURIComponent(t)).join('+');
      const res = await fetch(`/collections/all/${path}?view=recs&sort_by=${sort}`);
      if (!res.ok) return [];
      const holder = document.createElement('div');
      holder.innerHTML = await res.text();
      return Array.from(holder.querySelectorAll('li[data-rec-handle]'));
    }

    /* 1ブロック分の収集（ブロック間で独立して並列実行できる） */
    async collect(segments, limit, sort, rotor, excludeHandles, viewed) {
      const taken = new Set(excludeHandles);
      const out = [];

      for (const seg of segments) {
        if (out.length >= limit) break;

        let cards = [];
        try {
          cards = await this.fetchSegment(seg.t, sort);
        } catch (e) {
          continue;
        }
        if (!cards.length) continue;

        /* セッション乱数でオフセットを分散 */
        const offset = cards.length > limit ? rotor % cards.length : 0;
        const rotated = cards.slice(offset).concat(cards.slice(0, offset));
        const source = seg.t.join('+');

        /* 1周目：閲覧履歴も除外 */
        for (const card of rotated) {
          if (out.length >= limit) break;
          const h = card.dataset.recHandle;
          if (taken.has(h) || viewed.includes(h)) continue;
          taken.add(h);
          card.setAttribute('data-rec-source', source);
          out.push(card);
        }

        /* 2周目：埋まらなければ閲覧履歴の除外を解除 */
        if (out.length < limit) {
          for (const card of rotated) {
            if (out.length >= limit) break;
            const h = card.dataset.recHandle;
            if (taken.has(h)) continue;
            taken.add(h);
            card.setAttribute('data-rec-source', source);
            out.push(card);
          }
        }
      }
      return out;
    }

    async build() {
      let plan;
      try {
        plan = JSON.parse(this.dataset.plan || '[]');
      } catch (e) {
        return;
      }
      if (!plan.length) return;

      const currentHandle = this.dataset.currentHandle;
      const limits = {
        1: parseInt(this.dataset.block1Limit, 10) || 4,
        2: parseInt(this.dataset.block2Limit, 10) || 4
      };
      const seed = this.seed();
      const sort = this.SORTS[seed % this.SORTS.length];
      const viewed = this.history().slice(0, 10);

      const seg1 = plan.filter(s => s.b === 1);
      const seg2 = plan.filter(s => s.b === 2);

      /* ---- 比較枠と発見枠を並列で取得 ----
         互いの結果を参照できないため、発見枠は多めに確保しておき、
         揃った後で比較枠との重複を除いてから limit 件に切り詰める。 */
      /* オフセットは「商品ID + セッション乱数」。
         商品ごとに窓がずれ、かつ同一訪問中は同じページなら同じ結果になる。 */
      const currentId = parseInt(this.dataset.currentId, 10) || 0;
      const rotor = seed + currentId;

      const [raw1, raw2] = await Promise.all([
        this.collect(seg1, limits[1], sort, rotor, [currentHandle], viewed),
        this.collect(seg2, limits[2] * 2, sort, rotor, [currentHandle], viewed)
      ]);

      const used = new Set(raw1.map(c => c.dataset.recHandle));
      const picked = {
        1: raw1,
        2: raw2.filter(c => !used.has(c.dataset.recHandle)).slice(0, limits[2])
      };

      let shown = false;
      [1, 2].forEach(block => {
        const wrap = this.querySelector('[data-block="' + block + '"]');
        if (!wrap || !picked[block].length) return;
        const ul = wrap.querySelector('ul');
        picked[block].forEach((card, i) => {
          card.setAttribute('data-rec-block', block);
          card.setAttribute('data-rec-position', i + 1);
          ul.appendChild(card);
        });
        wrap.hidden = false;
        shown = true;
      });

      if (shown) this.hidden = false;
      this.recordHistory(currentHandle);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
